<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3vxLwR/tc-custom/9781398443464.jpg?1705766047921" alt="This image is the cover for the book Flight of The Rainbow Flame"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flight of The Rainbow Flame
      </h1>
      <p class="bookDescription body article font2">
        <p>Septuagenarian Sebastian Manheim finds a spaceship in his garden which has been buried where it crashed for 3000 years. The aliens are dead, but the computers are not, Seb develops a close relationship with one of them, the wisecracking Sobek, who is a pillar of light about four feet high. Seb agrees to be enhanced physically back to 25yrs and mentally to the highest human and some alien IQ by Sobek’s technology. Seb agrees to physically repair the spaceship, but until this is done Sobek, afraid of human discovery, wants to keep his presence on Earth a secret. Sobek’s life force is running out and they need to get back to their planet for supplies. In exchange for Sobek allowing the commercial exploitation of his technology, Seb agrees to get Sobek back into space. Sobek gives Seb technology which Seb makes into innovative products and weapons. This is so successful that they bring new billionaire Seb to the attention of the MI5 and the Prime Minister who wants all this new technology for the Nation’s Economy. Seb builds a mini spaceship to test the repairs, but the RAF think they have seen a UFO which they try to shoot down. Seb gets wounded and there are many attempts on Seb’s life, the kidnap of Seb’s beautiful wife, Marie, and the assassination of one of Seb’s sons, all of which is avenged…It is a race against time to get the spaceship away into space before the source of the technology is exposed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Komlosy
      </h2>
      
      <p class="authorDescription body article">Stephen, a member of Mensa, was born in 1940 during WWII. Educated at Highgate School, he left at 17 to run a provincial theatre with business partner Robert Stigwood. Back in London they became the paramount musical management company in London in the late ’50s and early ’60s, producing many number one hits. After parting with Robert in 1964, Stephen produced more hits, culminating in his management of Lionel Bart before Bart’s triumph with eleven Oscar Nominations for the film of Oliver. Later Stephen floated six public companies in the UK and USA and created three private property companies. He retired in 2017 to write and to manage his wife, Dr Patti Boulaye OBE. His autobiographical book You’ve Got to Pick a Pocket or Two was published in 2021 by Kaleidoscope Publishing.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3efa51c0